"use client";

import type { SxProps, Theme } from "@mui/material/styles";
import Box from "@mui/material/Box";

interface SunoIconProps {
  size?: number;
  sx?: SxProps<Theme>;
}

export default function SunoIcon({ size = 40, sx }: SunoIconProps) {
  return (
    <Box
      component="img"
      src="/suno-logo.webp"
      alt="Suno"
      sx={{ width: size, height: size, objectFit: "contain", ...sx }}
    />
  );
}
